import { coerceBooleanProperty } from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input
} from '@angular/core';
import { LegacyModeService } from '@boldpenguin/emperor-services';
import { EmperorUIButtonTypes } from '../../../button/models/button-types.model';
import { EmperorCardHeaderColor, EmperorThemeColor } from '../../../models';

@Component({
  selector: 'emperor-dialog-header',
  templateUrl: './dialog-header.component.html',
  styleUrls: ['./dialog-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmperorDialogHeaderComponent {
  @Input() title = '';
  @Input() shouldShowClose = true;
  @Input({ transform: coerceBooleanProperty }) enableAutoFocus = false;
  /**
   * @deprecated in M3
   */
  @Input() set color(color: EmperorCardHeaderColor) {
    this.cardHeaderColor = color;
    switch (color) {
      case EmperorCardHeaderColor.ACCENT:
        this.buttonColor = EmperorThemeColor.ACCENT;
        break;
      case EmperorCardHeaderColor.WARN:
        this.buttonColor = EmperorThemeColor.WARN;
        break;
      case EmperorCardHeaderColor.PRIMARY:
        this.buttonColor = EmperorThemeColor.PRIMARY;
        break;
      case 'none':
        this.buttonColor = 'none';
    }
  }
  EmperorUIButtonTypes = EmperorUIButtonTypes;
  cardHeaderColor: EmperorCardHeaderColor = EmperorCardHeaderColor.PRIMARY;
  buttonColor: EmperorThemeColor | 'none' = EmperorThemeColor.PRIMARY;
  legacyService = inject(LegacyModeService, { optional: true });
}
